export var FedopsInteractions;
(function (FedopsInteractions) {
    FedopsInteractions["RemoveItemInteraction"] = "remove-item-interaction";
    FedopsInteractions["UpdateQuantityInteraction"] = "update-quantity-interaction";
    FedopsInteractions["ApplyCouponInteraction"] = "apply-coupon-interaction";
})(FedopsInteractions || (FedopsInteractions = {}));
//# sourceMappingURL=constants.js.map